import { render } from "./NcrmPrivacyPreferenceLinks.vue?vue&type=template&id=40b6ac8a&scoped=true"
import script from "./NcrmPrivacyPreferenceLinks.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyPreferenceLinks.vue?vue&type=script&lang=js"

import "./NcrmPrivacyPreferenceLinks.vue?vue&type=style&index=0&id=40b6ac8a&scoped=true&lang=css"
import "./NcrmPrivacyPreferenceLinks.vue?vue&type=style&index=1&id=40b6ac8a&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40b6ac8a"]])

export default __exports__